import React from "react"
import {
  BmdActivityCard,
  BmdActivityLike,
} from "../../../modules/session/activity/bmd-activity-card"
import { usePlanLessonLocal } from "./PlanLessonContext"
import { getCheckboxProps } from "./PlanLessonHelpers"
import type { BasePlanningCardProps } from "./PlanLessonTypes"

// Thin wrapper that bridges the PlanLessonContext controller to the shared
// BmdActivityCard component. Session-detail.js renders the same card directly
// (without this wrapper) since it doesn't have PlanLessonContext.
export const LocalBmdActivityCard = ({
  isHomework,
  isPlanningSession,
  activity,
  sessionData,
  index,
  enrolment,
}: BasePlanningCardProps) => {
  const controller = usePlanLessonLocal()

  const checkbox = getCheckboxProps({
    controller,
    isPlanningSession,
    sessionData,
    activity,
    enrolment,
  })

  const deleteEnabled =
    controller.sessionStudentData?.session?.fk_tut_key === activity.fk_tut_key

  return (
    <BmdActivityCard
      activity={activity as unknown as BmdActivityLike}
      index={index}
      isHomework={isHomework}
      isPlanningSession={isPlanningSession}
      checkbox={checkbox}
      showContextMenu={true}
      onPreview={() => controller.onPreviewActivity(activity as any)}
      onRollOver={() => controller.onMoveActivityPopup(activity as any)}
      onRolloverToNextLesson={() =>
        controller.onRolloverActivityToNextSession(activity as any, 0)
      }
      onRolloverToHomework={() =>
        controller.onRolloverActivityToNextSession(activity as any, 1)
      }
      // Copy in session-completed context uses the dedicated "move-to-homework"
      // popup that creates a copy (matches legacy diagnostics behaviour).
      onCopyToHomework={() =>
        isPlanningSession
          ? controller.onActivityToHomeLesson(activity.pk_lesson_activity_key, 1)
          : controller.onMoveHomeworkActivityPopup(activity as any)
      }
      onCopyToLessonPlan={() =>
        controller.onActivityToHomeLesson(activity.pk_lesson_activity_key, 0)
      }
      onMoveToHomework={() =>
        controller.onActivityToHomework(activity.pk_lesson_activity_key, 1)
      }
      onMoveToLessonPlan={() =>
        controller.onActivityToHomework(activity.pk_lesson_activity_key, 0)
      }
      onDelete={() =>
        controller.onDelectActivityPopup(activity.pk_lesson_activity_key)
      }
      deleteEnabled={deleteEnabled}
      rollOverEnabled={isPlanningSession || !!sessionData?.session}
    />
  )
}

export default LocalBmdActivityCard
